/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clinicautocomplete_Searcherror2Inputs */

const en_clinicautocomplete_searcherror2 = /** @type {(inputs: Clinicautocomplete_Searcherror2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clinic search unavailable. Please type the name manually.`)
};

const fr_clinicautocomplete_searcherror2 = /** @type {(inputs: Clinicautocomplete_Searcherror2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recherche de clinique indisponible. Veuillez taper le nom manuellement.`)
};

/**
* | output |
* | --- |
* | "Clinic search unavailable. Please type the name manually." |
*
* @param {Clinicautocomplete_Searcherror2Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const clinicautocomplete_searcherror2 = /** @type {((inputs?: Clinicautocomplete_Searcherror2Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clinicautocomplete_Searcherror2Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clinicautocomplete_searcherror2(inputs)
	return fr_clinicautocomplete_searcherror2(inputs)
});
export { clinicautocomplete_searcherror2 as "clinicAutocomplete_searchError" }